








































import { Component, Vue } from 'vue-property-decorator'
import { CompanyAPI, UserAPI } from '@/api/backend-client'

@Component
export default class UserLogin extends Vue {
    loggingIn: boolean = false
    error: string = null
    email: string = ''
    password: string = ''
    show: boolean = false
    passwordFieldType: string = 'password'
    showPasswordButton: string = 'show'

    async performLogin(): Promise<void> {
        try {
            this.error = null
            this.loggingIn = true
            await UserAPI.login(this.email, this.password)

            if (UserAPI.isAuthenticated) {
                this.$root.$currentUser = await UserAPI.getCurrentUser()
                this.$root.$currentCompany = await CompanyAPI.getCurrentCompany()

                this.$emit('user-authenticated')
            }

        } catch (error) {

            // @todo: this error should come from the backend, but for now we'll use this generic one
            // this.error = error.message
            this.error = 'Er kon met deze gegevens niet worden ingelogd. Controleer je gebruikersnaam/wachtwoord en probeer het nogmaals.'
        } finally {
            this.loggingIn = false
        }
    }

    switchVisibility() {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
        this.showPasswordButton = this.passwordFieldType === 'password' ? 'show' : 'hide'
    }

}
